import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation
} from '@angular/core';

import { NotificationType } from '../notification-type';

/**
 * Inline notifications can be used to provide notifications to user that can persist on the page
 * they are also optionally dismissable by the user
 *
 * Usage:
 * <code><pre>
 * // Individual module import
 * import { InlineNotificationModule } from 'patternfly-ng/notification';
 * // Or
 * import { InlineNotificationModule } from 'patternfly-ng';
 *
 * // NGX Bootstrap
 * import { BsDropdownConfig, BsDropdownModule } from 'ngx-bootstrap/dropdown';
 *
 * &#64;NgModule({
 *   imports: [InlineNotificationModule, BsDropdownModule.forRoot(),...],
 *   providers: [BsDropdownConfig]
 * })
 * export class AppModule(){}
 * </pre></code>
 *
 * Optional:
 * <code><pre>
 * import { NotificationType } from 'patternfly-ng/notification';
 * </pre></code>
 */

export class InlineNotificationComponent {
  /**
   * The notification type (e.g., NotificationType.SUCCESS, NotificationType.INFO, etc.)
   */
   type: NotificationType;

  /**
   * The message to display within the notification
   */
   message: string;

  /**
   * The notification header
   */
   header: string;

  /**
   * Boolean to indicate whether or not notification can be dismissed
   */
   dismissable: boolean;

  /**
   * Indicates whether or not the notification is currently hidden
   */
   hidden: boolean = false;

  /**
   * The event emitted when the mouse hovers over and leaves a notification
   */
   hiddenChange = new EventEmitter<boolean>();


  /**
   * The default constructor
   */
  constructor() {
  }

  /**
   * Function called from the view when the notification is removed
   */
  public notificationRemove(): void {
    this.hidden = true;
    this.hiddenChange.emit(this.hidden);
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  encapsulation: ViewEncapsulation.None,
  selector: 'pfng-inline-notification',
  template: `<div class="alert alert-{{type}}" [ngClass]="{'alert-dismissable': dismissable === true}" *ngIf="!hidden"><button *ngIf="dismissable" (click)="notificationRemove()" type="button" class="close" aria-hidden="true"><span class="pficon pficon-close"></span></button> <span class="pficon pficon-ok" *ngIf="type === 'success'"></span> <span class="pficon pficon-info" *ngIf="type === 'info'"></span> <span class="pficon pficon-error-circle-o" *ngIf="type === 'danger'"></span> <span class="pficon pficon-warning-triangle-o" *ngIf="type === 'warning'"></span> <strong>{{header}}</strong> {{message}}</div>`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'type': [{ type: Input },],
'message': [{ type: Input },],
'header': [{ type: Input },],
'dismissable': [{ type: Input },],
'hidden': [{ type: Input },],
'hiddenChange': [{ type: Output, args: ['hiddenChange', ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
